import React, { FC, useCallback } from 'react';
import { Router, useHistory, useLocation } from 'react-router';

import { EvFlexColumn, EvFlexRow, EvIcon, InfoMsgMarkIcon } from '@evinced-private/ui-common';

import { handleDashboardRedirection } from 'src/apps/dashboard/helpers/NavigationHelpers';
import { useBannerStore } from 'src/apps/dashboard/stores/bannerStore';
import { ClarificationBanner } from 'src/common/components/clarification-banner/ClarificationBanner';
import { isConfigurationReady, isDashboardEnabled } from 'src/common/helpers/ConfigurationHelpers';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { useConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';

import { LABELS } from '../../constants/Labels';
import { DashboardRouter } from '../../router/DashboardRouter';
import { DashboardWrapperProps } from '../../types/DashboardTypes';
import { DashboardTabsNav } from '../dashboard-tabs-nav/DashboardTabsNav';

export const DashboardWrapper: FC<DashboardWrapperProps> = () => {
	const history = useHistory();
	const location = useLocation();
	const { configuration } = useConfiguration();
	const { visible: isBannerVisible, hidePermanently, setVisible } = useBannerStore();

	const isIssuesPage = location.pathname === RoutesHelper.getDashboardIssuesPath();
	const onHideBanner = useCallback(() => {
		setVisible(false);
	}, [setVisible]);

	if (!isConfigurationReady(configuration)) {
		return null;
	}

	if (!isDashboardEnabled(configuration)) {
		handleDashboardRedirection(history, configuration);
		return null;
	}

	return (
		<EvFlexColumn gap="LARGE" padding={['XLARGE', 'NONE']}>
			{isBannerVisible && (
				<ClarificationBanner hide={onHideBanner} hidePermanently={hidePermanently}>
					<EvIcon icon={InfoMsgMarkIcon} small />
					<EvFlexRow>{LABELS.DASHBOARD.ACCESSIBILITY_DASHBOARD_DESCRIPTION}</EvFlexRow>
				</ClarificationBanner>
			)}

			{!isIssuesPage && (
				<EvFlexColumn>
					<DashboardTabsNav />
				</EvFlexColumn>
			)}

			<EvFlexRow>
				<Router history={history}>
					<DashboardRouter />
				</Router>
			</EvFlexRow>
		</EvFlexColumn>
	);
};
